module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "loader-spinner"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSpinner),
      expression: "showSpinner"
    }],
    staticClass: "fa fa-spinner fa-spin fa-fw",
    class: _vm.size ? ("fa-" + _vm.size) : '',
    style: (_vm.color ? ("color: " + _vm.color + ";") : null),
    attrs: {
      "fixed-width": !_vm.size,
      "spin": "",
      "size": _vm.size ? _vm.size : null
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSpinner),
      expression: "!showSpinner"
    }]
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd8a823"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/LoaderSpinner.vue
// module id = 1297
// module chunks = 1